module.exports = __webpack_public_path__ + "img/microplastics-2-mobile.477da76c.png";